export function getHomeUrl() {
  if (import.meta.env.VITE_ENV === "production") {
    return "https://anything.perkspot.com/";
  }
  return "https://sandbox-hopper.perkspot.com/";
}
